import { ArrowLeft } from "lucide-react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Button from "../../Components/Button";
import PageHeader from "../../Components/PageHeader";
import SponsorDrilldownPanel from "../../Container/DiscoveryHub/SponsorDrilldownPanel";
import { normalizeRoleName } from "../../Utils/Constants/RoleConstants";
import { discoveryHubReturnPath } from "../../Utils/Helper/discoveryHubUi";
import {
  STORAGE_KEYS,
  getFromLocalStorage,
} from "../../Utils/Helper/LocalStorage";

const SponsorDrilldownPage = () => {
  const navigate = useNavigate();
  const { orgSlug } = useParams<{ orgSlug?: string }>();
  const loggedIn = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);
  const userRole = normalizeRoleName(loggedIn?.role);
  const withOrg = (path: string) => {
    const p = path.startsWith("/") ? path : `/${path}`;
    return orgSlug ? `/${orgSlug}${p}` : p;
  };
  const [params] = useSearchParams();
  const sponsorId = params.get("sponsorId");
  const period = params.get("period");
  const cycleId = params.get("cycleId");
  const returnTo = params.get("returnTo");
  const source = params.get("source");
  const backTo = returnTo
    ? decodeURIComponent(returnTo)
    : withOrg(discoveryHubReturnPath(userRole));

  const fromPoll2 = source === "poll2";
  const pageTitle = fromPoll2 ? "Team Feedback Drilldown" : "Sponsor Drilldown";

  const handleBack = () => {
    navigate(backTo);
  };

  const headerTitle = (
    <div className="flex items-center gap-2">
      <Button
        variant="clear"
        onClick={handleBack}
        className="min-w-0 p-1"
        aria-label="Go back"
      >
        <ArrowLeft size={15} color="#5F6368" />
      </Button>
      <span>{pageTitle}</span>
    </div>
  );

  if (!sponsorId) {
    return (
      <div className="mt-3 min-h-[calc(100vh-4rem)] overflow-hidden bg-white">
        <PageHeader title={headerTitle} hideIcon hideBreadcrumb />
        <div className="p-8 text-center text-gray-600">
          <p>No sponsor selected.</p>
          <Link
            to={withOrg(discoveryHubReturnPath(userRole))}
            className="text-purple-700 font-semibold"
          >
            Back to Discovery Hub
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-3 min-h-[calc(100vh-4rem)] overflow-hidden bg-white">
      <PageHeader
        title={headerTitle}
        // subTitle={pageSubTitle}
        hideIcon
        hideBreadcrumb
      />
      <div className="w-full bg-white p-3 md:p-4">
        <div className="rounded-md bg-gray-100 p-4 md:p-4">
          <SponsorDrilldownPanel
            sponsorId={sponsorId}
            period={period}
            cycleId={cycleId}
            backTo={backTo}
          />
        </div>
      </div>
    </div>
  );
};

export default SponsorDrilldownPage;
